import api from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
    loading: false,
  },

  getters: {
    list: (state) => state.list,
  },

  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const { data } = await api.get('ordemservicoitem', { params: { ...where, ...params } });
      return data;
    },
  },

  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    loading(state, request) {
      state.loading = request ?? false;
    },
  },
};
